export enum XAxisScale {
  CATEGORICAL = 'CATEGORICAL',
  LINEAR = 'LINEAR',
  TIME = 'TIME',
}
